import React from 'react';
import StepOne from '@/components/DialogIntroSequence/StepOne';
import { CREATOR } from '@/helpers/constants';

const DialogIntroSequence = () => (
  <StepOne lang="de" role={CREATOR} />
);

export default DialogIntroSequence;
